export const NEW_ENTITY = 'neu';
